module.exports = __webpack_public_path__ + "img/whatsapp-16.96ea633b.svg";